export default "__VITE_ASSET__Bzb7eJOh__"